import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { AffiliateService } from '@deltager/organizers/admin/core/services/affiliate.service';
import { isNullOrUndefined } from '@deltager/organizers/admin/shared/utils/object.utils';

@Pipe({
  name: 'price',
})
export class PricePipe extends CurrencyPipe implements PipeTransform {
  private readonly LOCALE: string;

  constructor(affiliateService: AffiliateService) {
    super(affiliateService.settings.cultureCode);
    this.LOCALE = affiliateService.settings.cultureCode;
  }

  /**
   * @param value The string to be formatted as currency.
   * @param display The format for the currency indicator. One of the following:
   *   - `code`: Show the code (such as `USD`).
   *   - `symbol`(default): Show the symbol (such as `$`).
   * currency.
   * For example, the Canadian dollar CAD has the symbol `CA$` and the symbol-narrow `$`. If the
   * locale has no narrow symbol, uses the standard symbol for the locale.
   *   - String: Use the given string value instead of a code or a symbol.
   * For example, an empty string will suppress the currency & symbol.
   *   - Boolean (marked deprecated in v5): `true` for symbol and false for `code`.
   * @param currencyCode The currency code. If the argument is not provided,
   * it's defined using locale
   */
  transform(value: number | string | null, display: 'fraction' | null = null, currencyCode: string = null): any {
    if (isNullOrUndefined(value)) {
      return '';
    }

    currencyCode ??= this.getCurrencyCode(this.LOCALE);
    const needFraction = display == 'fraction';

    const formatter = new Intl.NumberFormat(this.LOCALE, {
      style: 'currency',
      // @ts-ignore
      currencyDisplay: 'narrowSymbol',
      currency: currencyCode,
      minimumFractionDigits: needFraction ? 2 : 0,
      maximumFractionDigits: needFraction ? 2 : 0,
    });

    const numberValue = parseFloat(value.toString());

    return formatter.format(numberValue);
  }

  private getCurrencyCode(locale: string): string {
    switch (locale) {
      case 'nb-no':
        return 'NOK';
      case 'en-GB':
        return 'GBP';
      case 'en-US':
        return 'USD';
      case 'sv-SE':
        return 'SEK';
      case 'da-DK':
        return 'DKK';
      default:
        return 'NOK';
    }
  }
}
